import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import HttpClientXml from "../../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const CollegeUniversityPlacementStep4 = ({ data, setData, setCurrentStep, currentStep }) => {
  const navigate=useNavigate()
  const initialValues = {
    placementComparisonHeading: data?.placementComparisonHeading,
    placementComparisonText: data?.placementComparisonText,
    topRecruitersText: data?.topRecruitersText
  }

  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  console.log("KIU32", data?.placementComparisonHeading);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();

    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success("Data saved successfully");
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          placementComparisonHeading: formData?.placementComparisonHeading,
          placementComparisonText: formData?.placementComparisonText,
          topRecruitersText: formData?.topRecruitersText
        })
        // setCurrentStep(currentStep)
        navigate("/manage-college-university");
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  useEffect(()=>{
    setFormData(initialValues)
  },[data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Comparison Heading
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.placementComparisonHeading}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementComparisonHeading: e?.target?.value,
                  }));
                }}
                placeholder="Enter Comparison Heading"
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Comparison Information
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.placementComparisonText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    placementComparisonText: value,
                  }));
                }}
                placeholder="Enter Comparison Information"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                Recruiters Information
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.topRecruitersText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    topRecruitersText: value,
                  }));
                }}
                placeholder="Enter Recruiters Information"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 1 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityPlacementStep4;
